export enum AgencyFeature {
  VeteransResume = 'veterans_resume'
}
